import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

type BannerWrapperProps = {
  isShowingImage: boolean;
};

const BannerWrapper = styled('div')<BannerWrapperProps>(
  ({ theme, isShowingImage }) => ({
    position: 'relative',
    padding: '24px 48px',
    height: isShowingImage ? 300 : 200,
    backgroundColor: theme.palette.action.selected,
    transition: theme.transitions.create(['height']),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    [mediaQuery(800)]: {
      height: isShowingImage ? 200 : 180,
    },
    [mediaQuery(560)]: {
      padding: 24,
    },
    ':not(:hover) .thumbnail-controls-button:not(:focus):not(.menu-open)': {
      opacity: 0,
      transform: 'scale(0.9)',
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    borderBottom: `2px solid ${theme.palette.divider}`,
  })),
);

export default BannerWrapper;
